function init() {
    const plugins = document.querySelectorAll('.plugin-wrapper');
    plugins.forEach((plugin, index) => {
        const content = plugin.querySelector('.plugin-content');
        // Alternate plugin background
        if (index % 2 === 0) {
            plugin.classList.add('bg-white');
            if (content) content.classList.add('md:flex-row-reverse');
        } else {
            plugin.classList.add('bg-zinc-100');
            if (content) content.classList.add('md:flex-row');
        }
    });
}

export default {
    init
};
